import React, { useState } from 'react';
import { Form, Input, Button, Checkbox, message, Modal, Select } from 'antd';
import { Redirect } from "react-router-dom";
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import jwt from 'jsonwebtoken';
import jwt_decode from "jwt-decode";
import EcouiItemsChecker from '../../components/EcouiItemsChecker';
 
const { REACT_APP_OrgRegistryApi, REACT_APP_OrgjwtAud, REACT_APP_OrgjwtIss, REACT_APP_OrgjwtPrivate, REACT_APP_OrgjwtExp } = process.env;
const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
const { Option } = Select;
// const children = [];

function onChange(value) {

    sessionStorage.setItem('orgID', value.split("*")[0]);
    sessionStorage.setItem('LocationName', value.split("*")[1]);
    sessionStorage.setItem('LocationID', value.split("*")[2]);
}
 
const LOGIN_PROGRESS_KEY = 'login-progress';

const Login = () => {

    // Shows a persistent loading message and spins the SignIn button until the location modal opens
    const startLoading = (text) => {
        setLoading(true);
        message.loading({ content: text, key: LOGIN_PROGRESS_KEY, duration: 0 });
    };

    const stopLoading = () => {
        setLoading(false);
        message.destroy(LOGIN_PROGRESS_KEY);
    };

    const showModal = () => {
        stopLoading();
        setIsModalVisible(true);

    };
    const handleOk = () => {
        setIsModalVisible(false);

       // dispatch(signin({ username: '', isSigned: true, userData: '', accessToken: '', refreshToken: '' }));
        setSuccess(true);

    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    let userID = "";
    // let userResponse = undefined;
    var accessDec = undefined;
    var refreshDec = undefined;
    const dispatch = useDispatch();
    const [sussess, setSuccess] = useState(false);

    const [username, setUsername] = useState("");

    let bdy = {};

    const LoadOrg = (organizations, token) => {

        const timestamp = Math.floor(Date.now() / 1000) + 1000;
        var payload = {
            "aud": REACT_APP_OrgjwtAud,
            "exp": timestamp,
            "iss": REACT_APP_OrgjwtIss,
            "usertoken": token
        };


        var signOptions = {
            "algorithm": "RS256"
        };

        var privateKey = REACT_APP_OrgjwtPrivate;
        var jwttoken = jwt.sign(payload, privateKey.replace(/\\n/g, '\n'), signOptions);

        const vrequestOptions = {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + jwttoken,
            }
        };
      

            console.log('ldata.Result')
            fetch(`${REACT_APP_OrgRegistryApi}organisation/id/` + sessionStorage.getItem('orgID'), vrequestOptions)
            .then(lresponse => lresponse.json())
            .then(function (ldata) {
                   console.log(ldata.Result)
               // Locationsarr = Locationsarr.concat(ldata.Result)
            })

    
       


    }


    const LoadLocations = (organizations, token) => {

        const timestamp = Math.floor(Date.now() / 1000) + 1000;
        var payload = {
            "aud": REACT_APP_OrgjwtAud,
            "exp": timestamp,
            "iss": REACT_APP_OrgjwtIss,
            "usertoken": token
        };


        var signOptions = {
            "algorithm": "RS256"
        };

        var privateKey = REACT_APP_OrgjwtPrivate;
        var jwttoken = jwt.sign(payload, privateKey.replace(/\\n/g, '\n'), signOptions);
        console.log(jwttoken)
        const vrequestOptions = {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + jwttoken,
            }
        };
        // Wait for every organisation's locations before opening the modal
        Promise.all(
            organizations.map((organization) =>
                fetch(`${REACT_APP_OrgRegistryApi}locations/` + organization.OrganisationID, vrequestOptions)
                    .then(lresponse => lresponse.json())
                    .then(ldata => ldata.Result || [])
                    .catch(() => [])
            )
        ).then(function (results) {
            var Locationsarr = [].concat(...results)
            sessionStorage.setItem('children', JSON.stringify(Locationsarr));

            showModal();
        });



    }


    const onFinish = (values) => {

        bdy = { UserName: values.username, Password: values.password };

        startLoading('Please wait... Validating your login')



        const timestamp = Math.floor(Date.now() / 1000) + 1000;
        var payload = {
            "aud": REACT_APP_OrgjwtAud,
            "exp": timestamp,
            "iss": REACT_APP_OrgjwtIss
        };

        var signOptions = {
            "algorithm": "RS256"
        };

        var privateKey = REACT_APP_OrgjwtPrivate.replace(/\\n/g, '\n');



        var token = jwt.sign(payload, privateKey, signOptions);

        // console.log("JWT AUTH==>>", token, payload, privateKey, signOptions);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + token,
            },
            body: JSON.stringify(bdy)
        };

        //  console.log(values)

        fetch(`${REACT_APP_OrgRegistryApi}user/login`, requestOptions)
            .then(response => response.json())
            .then((resp) => {

                try {
                    const userResponse = resp.Result
                    console.log("Login resp ===>>", resp)
                    accessDec = jwt.decode(userResponse.AccessToken);
                    refreshDec = jwt.decode(userResponse.RefreshToken);
                    userID = accessDec.userid;
                    Cookies.set('infinity', userResponse.AccessToken, { expires: new Date(accessDec.exp * 1000) });
                    Cookies.set('embose', userResponse.RefreshToken, { expires: new Date(refreshDec.exp * 1000) });
                    sessionStorage.setItem('refreshToken', userResponse.RefreshToken);
                    sessionStorage.setItem('accessToken', userResponse.AccessToken);
                    startLoading('Please wait.. fetching your details.')

                    // window.location.href = "/dashboard/" + sessionStorage.getItem('appid')

                    const expireTime = new Date().getTime() + (REACT_APP_OrgjwtExp * 1000)


                    var payload = {
                        "aud": REACT_APP_OrgjwtAud,
                        "exp": timestamp,
                        "iss": REACT_APP_OrgjwtIss,
                        "usertoken": userResponse.AccessToken
                    };


                    var signOptions = {
                        "algorithm": "RS256"
                    };

                    var privateKey = REACT_APP_OrgjwtPrivate;
                    var token = jwt.sign(payload, privateKey.replace(/\\n/g, '\n'), signOptions);

                    const vrequestOptions = {
                        method: 'GET',
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ` + token,
                        }
                    };

                    var decoded = jwt_decode(userResponse.AccessToken);

                    fetch(`${REACT_APP_OrgRegistryApi}user/` + decoded.userid, vrequestOptions)
                        .then(response => response.json())
                        .then(function (data) {

                            console.log(data.Result)
                            sessionStorage.setItem('appid', 'witmegreport');
                            sessionStorage.setItem('loggedin', true);
                            sessionStorage.setItem('userID', data.Result.UserID);
                            
                            sessionStorage.setItem('fullUserDetails', JSON.stringify(data.Result));


                            fetch(`${REACT_APP_OrgRegistryApi}registereduser/user/` + decoded.userid, vrequestOptions)
                                .then(vresponse => vresponse.json())
                                .then(function (vdata) {

                                    if (vdata.Result.length > 0) {
                                        startLoading('Please wait.. loading your organization locations.')
                                        sessionStorage.setItem('appID', data.Result.UserID + "-app");
                                        sessionStorage.setItem('orgID', '');
                                        LoadLocations(vdata.Result, userResponse.AccessToken)
                                       // LoadOrg(vdata.Result, userResponse.AccessToken)
                                        //console.log(sessionStorage.getItem('orgID'))

                                        //window.location.href="/"
                                        //dispatch(signin({ username: username, isSigned: true, userData: accessDec, accessToken: userResponse.AccessToken, refreshToken: userResponse.RefreshToken }));
                                        //setSuccess(true);
                                    } else {
                                        stopLoading();
                                        message.warning('No organizations are registered for this user.');
                                    }
                                    // else {
                                    //     sessionStorage.setItem('appID', data.Result.UserID + "-app");
                                    //     sessionStorage.setItem('orgID', vdata.Result[0].OrganisationID);
                                    //     sessionStorage.getItem('appID', vdata.Result[0].OrganisationID);
                                    //    // dispatch(signin({ username: username, isSigned: true, userData: accessDec, accessToken: userResponse.AccessToken, refreshToken: userResponse.RefreshToken }));
                                    //     setSuccess(true);
                                    // }


                                })
                                .catch(() => {
                                    stopLoading();
                                    message.error('Could not load your organization details. Please try again.');
                                })

                        })
                        .catch(() => {
                            stopLoading();
                            message.error('Could not load your user details. Please try again.');
                        })


                } catch (err) {
                    stopLoading();
                    message.error('Invalid Login!!  Username/Password is invalid.');
                }
            })
            .catch((error) => {
                stopLoading();
                message.error('Invalid Login!!  Username/Password is invalid.');
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    if (sussess) {
        return <Redirect to='/' />;
    }



    return (
   
            <div style={{}}>

                <div style={{ maxWidth: '480px', margin: 'auto', marginTop: '20vh', backgroundColor: '#eeefff', padding: '24px' }}>

                    <Form
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                            <Input value={username} onChange={(e) => { setUsername(e.target.value) }} />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item {...tailLayout} name="remember" valuePropName="checked">
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item>

                        <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                SignIn
                            </Button>
                        </Form.Item>
                    </Form>


                    <Modal title="Organization Location Selection" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                        <p>You're belongs to more than one Organization.
                            Please select your Organization location to view the reports</p>


                        <Select style={{ width: 120 }}
                            style={{ width: 200 }}
                            onChange={onChange}
                            placeholder="Select a location"
                        >
                            {sessionStorage.getItem('children') ? (
                                JSON.parse(sessionStorage.getItem('children')).map(location =>
                                    <Option value={location.OrganisationID + '*' + location.Name + '*' + location.LocationID}>{location.Name}</Option>
                                )
                            ) : ('')
                            }

                        </Select>

                    </Modal>


                </div>
            </div>
        
    );
};

export default Login;
